import { createSelector } from '@reduxjs/toolkit';

import { isRouteInGroup } from '../../Helper';

const EMPTY_OBJ = {};

const utility = (state) => state?.utility;

const orderDetailsSelector = createSelector(
  utility,
  (state) => state.orderDetails || EMPTY_OBJ,
);
const selectOrderDetailsFilter = createSelector(
  utility,
  (state) => state.orderDetailsFilter || EMPTY_OBJ,
);
const selectDifferentMethod = createSelector(
  utility,
  (state) => state?.chooseDifferentPaymentMethod,
);
const selectReservationCheckoutData = createSelector(
  utility,
  (state) => state.reservationCheckoutData,
);
const selectRoute = createSelector(utility, (state) => state.route);
const selectPage = createSelector(selectRoute, (route) =>
  isRouteInGroup(route?.name),
);
const successfulOrderSelector = createSelector(
  utility,
  (state) => state?.successfulOrder || [],
);
const userAddressFetchingSelector = createSelector(
  utility,
  (state) => state?.gettingUserData.address,
);
const userDetailsFetchingSelector = createSelector(
  utility,
  (state) => state?.gettingUserData.details,
);
const userCartFetchingSelector = createSelector(
  utility,
  (state) => state?.gettingUserData.cart,
);
const selectMealPlanHintEnabled = createSelector(
  utility,
  (state) => state.mealPlanHintEnabled,
);

export {
  orderDetailsSelector,
  selectOrderDetailsFilter,
  selectDifferentMethod,
  selectReservationCheckoutData,
  successfulOrderSelector,
  userAddressFetchingSelector,
  userCartFetchingSelector,
  userDetailsFetchingSelector,
  selectMealPlanHintEnabled,
  selectRoute,
  selectPage,
};
